import { Component, OnInit } from '@angular/core';
import { Logger } from './core/logger.service';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  // title = 'PLC Convertor';
  // constructor( private translate: TranslateService ) {
  //   translate.setDefaultLang('en');
  // }

  constructor( ) {
  }

  ngOnInit() {
    // Setup logger
    // if (environment.production) {
    //   Logger.enableProductionMode();
    // }
    log.debug('init');
    // tslint:disable-next-line: max-line-length
    // var userLang = environment.supportedLanguages.findIndex(spt => spt.code == navigator.language) > -1 ? navigator.language : environment.defaultLanguage;
  }
}
